import { render, staticRenderFns } from "./4-onboarding.vue?vue&type=template&id=41a0c81d&scoped=true&"
import script from "./4-onboarding.vue?vue&type=script&lang=js&"
export * from "./4-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./4-onboarding.vue?vue&type=style&index=0&id=41a0c81d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0c81d",
  null
  
)

export default component.exports